<forge-popover #popover class="grid-action-popover" [noAnchor]="true" positionStrategy="absolute"
  preset="list" (forge-popover-toggle)="onPopoverToggle()">
  <forge-menu>
    <forge-list #optionList dense role="menu" (keydown)="onKeyDown($event)">
      @for (item of menuItems; track item; let i = $index) {
        <forge-list-item role="presentation"
          focus-propagation="off" (click)="onItemClick(item, $event)">
          <button type="button" role="menuitem" [attr.tabindex]="i === 0 ? 0 : -1">
            {{item.caption}}
          </button>
        </forge-list-item>
      }
    </forge-list>
  </forge-menu>
</forge-popover>
